import Cart from './cart';

export default new Cart();
